var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.07838 13.75H7.92278C9.23438 13.75 10.323 12.7364 10.4164 11.4281L10.8683 3.85128C9.5394 3.38505 8.05989 3.125 6.50058 3.125C4.94127 3.125 3.46176 3.38505 2.13281 3.85128L2.58473 11.4281C2.67818 12.7364 3.76678 13.75 5.07838 13.75Z",
    fill: "#28303F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21886 2.75978V2.5C8.21886 1.55076 7.44935 0.78125 6.50011 0.78125C5.55087 0.78125 4.78136 1.55076 4.78136 2.5V2.75978C3.29075 2.94119 1.89819 3.35498 0.66976 3.95362C0.437039 4.06703 0.340319 4.34763 0.453728 4.58035C0.567138 4.81307 0.847732 4.90979 1.08045 4.79638C2.63773 4.03748 4.49745 3.59375 6.50011 3.59375C8.50277 3.59375 10.3625 4.03748 11.9198 4.79638C12.1525 4.90979 12.4331 4.81307 12.5465 4.58035C12.6599 4.34763 12.5632 4.06703 12.3305 3.95362C11.102 3.35498 9.70947 2.94119 8.21886 2.75978Z",
    fill: "#28303F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 5.78125C5.50888 5.78125 5.71875 5.99112 5.71875 6.25V10C5.71875 10.2589 5.50888 10.4688 5.25 10.4688C4.99112 10.4688 4.78125 10.2589 4.78125 10V6.25C4.78125 5.99112 4.99112 5.78125 5.25 5.78125Z",
    fill: "#28303F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 5.78125C8.00888 5.78125 8.21875 5.99112 8.21875 6.25V10C8.21875 10.2589 8.00888 10.4688 7.75 10.4688C7.49112 10.4688 7.28125 10.2589 7.28125 10V6.25C7.28125 5.99112 7.49112 5.78125 7.75 5.78125Z",
    fill: "#28303F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.9437c666b4f84f62c264ac1ccc86d8a2.svg";
export { ForwardRef as ReactComponent };